import React from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as Yup from "yup";
import { Formik } from "formik";
import SelectInput from "../inputs/SelectInput";

const useStyles = makeStyles(() => ({
  styledTextfield: {
    "& .MuiInputBase-root": {
      borderRadius: "12px",
    },
  },
  styledAnchor: {
    borderBottom: "1px solid #B1D238",
  },
  anchorTag: {
    fontWeight: 500,
    borderBottom: "1px solid black",
    color: "black",
  },
}));

const SignupProfessionalStepTwo = () => {
  const classes = useStyles();

  const INI_DATA = {
    title: "",
    location: "",
    line: "",
    description: "",
  };

  const SCHEMA = {
    title: Yup.string().required("Field is required"),
    location: Yup.string().required("Field is required"),
    line: Yup.string().required("Field is required"),
    description: Yup.string().required("Field is required"),
  };
  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700}>
          Welcome, John!
        </Typography>
        <Typography variant="h4" fontWeight={500}>
          Your profile helps us connect you with the most relevant events,
          speaker and/or sponsorship opportunities
        </Typography>
      </Stack>
      <Formik
        initialValues={INI_DATA}
        validationSchema={Yup.object().shape(SCHEMA)}
        onSubmit={(values) => console.log(values)}
        render={({
          handleChange,
          values,
          touched,
          setFieldValue,
          errors,
          handleSubmit,
        }: any) => (
          <Stack width="50%" spacing={2}>
            <form onSubmit={handleSubmit}>
              <Stack spacing={0.5}>
                <Typography>Business Title*</Typography>
                <TextField
                  className={classes.styledTextfield}
                  fullWidth
                  style={{ border: 0, padding: 0 }}
                  id="title"
                  helperText={
                    touched.title && errors !== null ? errors.title : ""
                  }
                  error={touched.title && errors !== null && errors.title}
                  onChange={handleChange}
                  value={values.title}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>Location*</Typography>
                <TextField
                  className={classes.styledTextfield}
                  fullWidth
                  style={{ border: 0, padding: 0 }}
                  id="location"
                  helperText={
                    touched.location && errors !== null ? errors.location : ""
                  }
                  error={touched.location && errors !== null && errors.location}
                  onChange={handleChange}
                  value={values.location}
                  variant="outlined"
                />
                <Typography>
                  {" "}
                  We’ll use your location to show events near you
                </Typography>
              </Stack>

              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>Please describe your business line*</Typography>
                <SelectInput
                  placeholder="Select One"
                  value={values.line}
                  roundedCorners={true}
                  onChange={(event) =>
                    setFieldValue("line", event.target.value)
                  }
                  options={[{ label: "Other", value: "Other" }]}
                />
              </Stack>
              {values.line === "Other" ? (
                <Stack spacing={0.5} position="relative" mt={1.5}>
                  <Typography> Your business line*</Typography>
                  <TextField
                    className={classes.styledTextfield}
                    type="text"
                    fullWidth
                    id="description"
                    style={{ border: 0, padding: 0 }}
                    helperText={
                      touched.description && errors !== null
                        ? errors.description
                        : ""
                    }
                    error={
                      touched.description &&
                      errors !== null &&
                      errors.description
                    }
                    onChange={handleChange}
                    value={values.description}
                    variant="outlined"
                  />
                </Stack>
              ) : null}

              <Box mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  fullWidth
                >
                  Next
                </Button>
              </Box>
            </form>
          </Stack>
        )}
      />
    </Stack>
  );
};
export default SignupProfessionalStepTwo;
